module.exports = __webpack_public_path__ + "img/图片15.4eb9fa19.png";